"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  return "grammar " + name;
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/name.js
// module id = 200
// module chunks = 0